module.exports = __webpack_public_path__ + "img/adv-bird-2.9a8b8301.png";